import React from 'react';


const AddressForm = ({ address, address2, city, state, zip, country, phone1, phone2, email, memberType, isNameConfidential, onChangeInput, onChangeCheckbox, role, referenceMemberTypes }) => (

    <div style={{ backgroundColor: "yellow" }}>
        <div className="text-center bold-text">Address and other details</div>
        <div className="form-row p-3">
            <div className="col">
                <div className="md-form">
                    <label htmlFor="address">Address Line 1 or Business Name</label>
                    <input
                        onChange={onChangeInput}
                        type="text"
                        id="address"
                        placeholder="Address"
                        name="address"
                        className="form-control"
                        value={address}
                    />
                </div>
            </div>
            <div className="col">
                <div className="md-form">
                    <label htmlFor="address2">Address Line 2</label>
                    <input
                        onChange={onChangeInput}
                        type="text"
                        id="address2"
                        placeholder="Address"
                        name="address2"
                        className="form-control"
                        value={address2}
                    />
                </div>
            </div>
        </div>
        <div className="form-row p-3">
            <div className="col">
                <div className="md-form">
                    <label htmlFor="city">City</label>
                    <input
                        onChange={onChangeInput}
                        type="text"
                        id="city"
                        placeholder="City"
                        name="city"
                        className="form-control"
                        value={city}
                    />
                </div>
            </div>
            <div className="col">
                <div className="md-form">
                    <label htmlFor="state">State</label>
                    <input
                        onChange={onChangeInput}
                        type="text"
                        id="state"
                        placeholder="State"
                        name="state"
                        className="form-control"
                        value={state}
                    />
                </div>
            </div>
            <div className="col">
                <div className="md-form">
                    <label htmlFor="zip">ZipCode</label>
                    <input
                        onChange={onChangeInput}
                        type="text"
                        id="zip"
                        placeholder="Zip"
                        name="zip"
                        className="form-control"
                        value={zip}
                    />
                </div>
            </div>
            <div className="col">
                <div className="md-form">
                    <label htmlFor="country">Country</label>
                    <input
                        onChange={onChangeInput}
                        type="text"
                        id="country"
                        placeholder="Country"
                        name="country"
                        className="form-control"
                        value={country}
                    />
                </div>
            </div>
        </div>
        <div className="form-row p-3">
            <div className="col">
                <div className="md-form1">
                    <label htmlFor="email">E-Mail</label>
                    <input
                        onChange={onChangeInput}
                        type="text"
                        id="email"
                        placeholder="Email Address"
                        name="email"
                        className="form-control"
                        value={email}
                    />
                </div>
            </div>
            <div className="col">
                <div className="md-form">
                    <label htmlFor="confidentialName" style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            type="checkbox"
                            id="confidentialName"
                            name="isNameConfidential"
                            checked={isNameConfidential}
                            onChange={onChangeCheckbox}
                            style={{ marginRight: '10px' }} // Adjust the value as needed
                        />
                        Keep name confidential
                    </label>
                </div>
            </div>
            <div className="col">
                <div className="md-form">
                    <label htmlFor="memberType">Member Type <span className="text-danger">*</span></label>
                    <select
                        onChange={onChangeInput}
                        id="memberType"
                        name="memberType"
                        className="form-control"
                        value={memberType || 'DEVOTEE'}
                    >
                        {referenceMemberTypes && referenceMemberTypes.length > 0 ? (
                            referenceMemberTypes.map(opt => (
                                <option key={opt.id} value={opt.value}>{opt.value}</option>
                            ))
                        ) : (
                            <option value="DEVOTEE">DEVOTEE</option>
                        )}
                    </select>
                </div>
            </div>
        </div>
        {/* Phone numbers in a separate row */}
        <div className="form-row p-3">
            <div className="col">
                <div className="md-form1">
                    <label htmlFor="phone1">Primary Phone</label>
                    <input
                        onChange={onChangeInput}
                        type="text"
                        id="phone1"
                        placeholder="Phone"
                        name="phone1"
                        className="form-control"
                        value={phone1}
                    />
                </div>
            </div>
            <div className="col">
                <div className="md-form">
                    <label htmlFor="phone2">Secondary Phone</label>
                    <input
                        onChange={onChangeInput}
                        type="text"
                        id="phone2"
                        placeholder="Phone"
                        name="phone2"
                        className="form-control"
                        value={phone2}
                    />
                </div>
            </div>
        </div>

    </div>
);

export default AddressForm;